<form (ngSubmit)="login()" [formGroup]="personalNumberForm">
	<div class="obg-m-sga-login-form-content">
		<ng-content select=".login-title"></ng-content>
		<mat-form-field>
			<input
				matInput
				formControlName="personalNumber"
				type="tel"
				test-id="personal-number"
				data-test-id="personal-number"
				placeholder="{{ 'sga-register.personal-number.label' | translate }}"
				maxlength="13"
				(blur)="gtmEventAction('BankID')"
			/>
			<mat-icon matSuffix><img obgImageContent="general.register.bankid" /></mat-icon>
		</mat-form-field>
		<div class="obg-m-sga-login-form-messages">
			<label
				*ngIf="!personalNumberForm.controls.personalNumber.touched"
				test-id="help-text"
				class="obg-m-sga-login-form-pno-help"
				[innerHtml]="'sga-register.personal-number.help' | translate"
			>
			</label>
			<obg-common-validation-renderer
				[input]="personalNumberForm.controls.personalNumber"
				translationPrefix="sga-register.personal-number"
			>
			</obg-common-validation-renderer>
			<div
				*ngIf="errorMessage && showError"
				class="validation-error"
				attr.test-id="error"
				[innerHTML]="(errorMessage | translate) + customerCanLogInAt"
			></div>
		</div>
	</div>
	<div class="obg-m-sga-login-form-actions">
		<div class="obg-m-sga-login-form-cancel" *ngIf="polling; else formEnabledView">
			<span [innerHtml]="'sga-verification-transaction.polling-bankid' | translate"></span>
			<div>
				<span (click)="submitCancel()" class="obg-m-sga-login-form-cancel-button"
					>{{ 'general.cancel' | translate }}</span
				>
			</div>
		</div>
		<ng-template #formEnabledView>
			<mat-slide-toggle
				*ngIf="personalNumberForm.controls.shouldRememberUser"
				formControlName="shouldRememberUser"
				test-id="login-should-remember-user"
				(change)="gtmEventAction('RememberMe')"
				color="primary"
				>{{ 'login.rememberEmail.placeholder' | translate }}
			</mat-slide-toggle>
			<button
				[disabled]="!personalNumberForm.valid || isVerificationSuccess"
				mat-flat-button
				color="accent"
				class="primary-button"
				test-id="login-submit"
				data-test-id="login-submit"
			>
				{{ submitBtnKey! | translate }}
			</button>
			<ng-content select="secondary-button"></ng-content>
		</ng-template>
	</div>
</form>
